if ( typeof StoreSelector !== 'function' ) {

  class StoreSelector extends HTMLElement {

    // Store hours: [open, close] per day (0=Sun..6=Sat), Eastern time. Mirrors the
    // table in component-pickup-availability.js (keyed by handleized store name) so the
    // card status and the pickup timing stay consistent. The merchant-configured
    // closing-times block still supplies the displayed close time when open.
    static STORE_HOURS = {
      "brunswick":       [[10,16],[8,19],[8,19],[8,19],[8,19],[8,19],[8,18]],
      "colonie":         [[10,16],[8,19],[8,19],[8,19],[8,19],[8,19],[8,18]],
      "coxsackie":       [[10,16],[8,19],[8,19],[8,19],[8,19],[8,19],[8,18]],
      "nassau":          [[10,16],[8,19],[8,19],[8,19],[8,19],[8,19],[8,18]],
      "waterford":       [[10,16],[8,19],[8,19],[8,19],[8,19],[8,19],[8,18]],
      "wynantskill":     [[10,16],[8,19],[8,19],[8,19],[8,19],[8,19],[8,18]],
      "niskayuna":       [[10,16],[8,18],[8,18],[8,18],[8,18],[8,18],[8,18]],
      "palatine-bridge": [[10,16],[8,18],[8,18],[8,18],[8,18],[8,18],[8,17]],
      "downtown-troy":   [[0,0],  [8,17],[8,17],[8,17],[8,17],[8,17],[8,13]],
    };

    static DAY_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

    static formatHour(h) {
      const whole = Math.floor(h);
      const min = Math.round((h - whole) * 60);
      const ampm = whole >= 12 ? 'pm' : 'am';
      let display = whole % 12;
      if (display === 0) display = 12;
      return min ? `${display}:${String(min).padStart(2, '0')}${ampm}` : `${display}${ampm}`;
    }

    constructor() {

      super();

      this.mainSelector = this.hasAttribute('data-main-selector');
      this.storeSelectorButton = this.mainSelector ? document.querySelector('[data-js-select-store]') : null;
      this.canChangeStore = true;

      if ( this.hasAttribute('data-ace-locator') ) {
        this.initAceLocator();
        return;
      }

      const interactiveMap = document.getElementById(this.dataset.mapSelector);

      if ( this.mainSelector && this.hasAttribute('data-single-store') ) {
        localStorage.setItem('selected-store', this.querySelector('.store-selector-item').getAttribute('data-handle'));
      }
      const selectedStore = localStorage.getItem('selected-store');
      let selectedStoreFound = false;
      
      this.storesList = [];
      this.querySelectorAll('.store-selector-item').forEach(elm=>{

        const item = elm;
        this.storesList[item.dataset.handle] = item.dataset.title;

        if ( selectedStore && selectedStore == item.getAttribute('data-handle') ) {

          this._setSelectedStore(item, item);
          this.changeSelectedStoreHandleContent(selectedStore);
          selectedStoreFound = true;

          if ( interactiveMap ) {
            interactiveMap.addEventListener('ready', ()=>{
              setTimeout(()=>{
                google.maps.event.trigger(interactiveMap.markers[item.dataset.handle], 'click');
              }, 1000);
            })
          }

        }

        if ( ! this.hasAttribute('data-single-store') ) {

          // A real <button>, not a tabIndex'd <div>: it is announced as a
          // button, gets Enter/Space for free, and can carry aria-expanded.
          // Without an accessible name it was 9 anonymous controls on the page
          // (axe aria-command-name) — the store name supplies one.
          const header = item.querySelector('.js-accordion-tab');
          const panelId = header.dataset.panelId || '';
          const storeName = item.dataset.title || 'this store';

          const toggleEl = document.createElement('button');
          toggleEl.type = 'button';
          toggleEl.className = `js-accordion-tab-toggle ${this.mainSelector ? 'js-accordion-tab-toggle--main' : ''}`;
          toggleEl.setAttribute('aria-expanded', item.classList.contains('store-selector-item--active') ? 'true' : 'false');
          if ( panelId ) toggleEl.setAttribute('aria-controls', panelId);
          toggleEl.setAttribute('aria-label', `${storeName} — store details`);
          toggleEl.innerHTML = KROWN.settings.symbols.toggle_pack_alternate;
          header.appendChild(toggleEl);

          if ( this.mainSelector ) {
            const changeStoreEv = e=>{
              this._clearSelectedStore(item);
              this._setSelectedStore(item, e.target);
              if ( interactiveMap ) {
                if ( item.classList.contains('store-selector-item--store--active') ) {
                  google.maps.event.trigger(interactiveMap.markers[item.dataset.handle], 'click');
                }
              }
            }
            item.querySelector('.store-selector-item__input-container').addEventListener('click', changeStoreEv);
            item.querySelector('.store-selector-item__input-container').addEventListener('keyup', e=>{
              if ( e.keyCode == window.KEYCODES.RETURN ) {
                changeStoreEv(e);
              }
            });
          }

          const openAccordionEv = () => {
            this._openStoreTab(item);
            this.canChangeStore = false;

            if ( interactiveMap ) {
              if ( item.classList.contains('store-selector-item--active') ) {
                google.maps.event.trigger(interactiveMap.markers[item.dataset.handle], 'click');
              }
            }

            if ( item.querySelector('css-slider') ) {
              item.querySelector('css-slider').resetSlider();
            }
          }

          const accordionControl = item.querySelector(`${this.mainSelector ? '.js-accordion-tab-toggle' : '.js-accordion-tab'}`);
          accordionControl.addEventListener('click', openAccordionEv);
          accordionControl.addEventListener('keyup', e=>{
            // The toggle used to be a tabIndex'd <div>, which does NOT fire click
            // on Enter — hence this keyup handler. It is a real <button> now, so
            // Enter already produces a click; running this as well would call
            // openAccordionEv twice and instantly re-close the panel it opened.
            // Keep the handler for any other focusable content in the header.
            if ( e.target.closest && e.target.closest('.js-accordion-tab-toggle') ) return;
            if ( e.keyCode == window.KEYCODES.RETURN ) {
              openAccordionEv();
            }
          });

        }

      });

      if ( this.storeSelectorButton && selectedStoreFound == false ) {
        this.storeSelectorButton.classList.add('show-select-label');
      }

      if ( interactiveMap ) {
        interactiveMap.addEventListener('marker', (e)=>{
          if ( this.canChangeStore ) {
            const item = this.querySelector(`.store-selector-item[data-handle="${e.detail.store}"]`);
            if ( ! item.classList.contains('store-selector-item--store--active' ) ) {
              this._clearSelectedStore(item);
              this._setSelectedStore(item, item);
            }
          } else {
            this.canChangeStore = true;
          }
        });
      }
      
      if ( document.querySelector('[data-js-select-store]') ) {
        const storeChanged = new CustomEvent('storechanged');
        document.querySelector('[data-js-select-store]').addEventListener('click', e=>{
          e.preventDefault();
          if ( this.querySelector('.store-selector-item--store--active') ) {
            const selectedStoreNew = this.querySelector('.store-selector-item--store--active').getAttribute('data-handle');
            localStorage.setItem('selected-store', selectedStoreNew);
            this.changeSelectedStoreHandleContent(selectedStoreNew);
          } else {
            localStorage.removeItem('selected-store');
            this.changeSelectedStoreHandleContent();
          }
          this.dispatchEvent(storeChanged);
        });
      }

    }

    initAceLocator() {
      this.interactiveMap = document.getElementById(this.dataset.mapSelector);
      this.nearbyContainer = this.querySelector('[data-nearby-stores]');
      this.myStoreContainer = this.querySelector('[data-my-store]');
      this.myStoreSection = this.querySelector('[data-my-store-section]');
      this.locationForm = this.querySelector('[data-location-search]');
      this.locationInput = this.querySelector('[data-location-input]');
      this.locationButton = this.querySelector('.sl-locator__search-button');
      this.locationStatus = this.querySelector('[data-location-status]');
      this.geoButton = this.querySelector('[data-use-location]');
      this.cards = Array.from(this.querySelectorAll('.store-selector-item'));
      this.storesList = [];
      this.nearestHandle = null;

      this.cards.forEach(card => {
        this.storesList[card.dataset.handle] = card.dataset.title;
        this._setAceStatus(card);

        card.querySelector('[data-set-store]')?.addEventListener('click', event => {
          event.preventDefault();
          this._setAceSelectedStore(card.dataset.handle);
        });

        card.querySelector('[data-toggle-details]')?.addEventListener('click', event => {
          event.preventDefault();
          this._toggleAceDetails(card);
        });

        card.addEventListener('mouseenter', () => this._focusAceMap(card.dataset.handle, false));
      });

      if ( this.mainSelector && this.hasAttribute('data-single-store') && this.cards[0] ) {
        localStorage.setItem('selected-store', this.cards[0].dataset.handle);
      }

      this.locationForm?.addEventListener('submit', event => {
        event.preventDefault();
        const query = this.locationInput?.value.trim();
        if ( ! query ) {
          this._showAceLocationStatus('Enter a ZIP code or city to find the closest store.', 'error');
          this.locationInput?.focus();
          return;
        }

        this._setAceLocationLoading(true, 'Searching stores...');
        this._geocodeAceLocation(query)
          .then(point => this._sortAceStoresFrom(point, `Stores closest to ${query}`))
          .catch(() => this._showAceLocationStatus('We could not find that location. Try a ZIP code or city and state.', 'error'))
          .finally(() => this._setAceLocationLoading(false));
      });

      this._attachAceLocationAutocomplete();

      this.geoButton?.addEventListener('click', event => {
        event.preventDefault();
        if ( ! navigator.geolocation ) {
          this._showAceLocationStatus('Current location is not available in this browser.', 'error');
          return;
        }

        this._setAceLocationLoading(true, 'Finding your current location...');
        navigator.geolocation.getCurrentPosition(
          position => {
            this._sortAceStoresFrom({
              lat: position.coords.latitude,
              lng: position.coords.longitude
            }, 'Stores closest to your current location');
            this._setAceLocationLoading(false);
          },
          () => {
            this._setAceLocationLoading(false);
            this._showAceLocationStatus('Location permission was blocked. Enter a ZIP code instead.', 'error');
          },
          { enableHighAccuracy: false, timeout: 10000, maximumAge: 300000 }
        );
      });

      if ( this.interactiveMap ) {
        this.interactiveMap.addEventListener('marker', event => {
          if ( this.suppressNextMarkerScroll ) {
            this.suppressNextMarkerScroll = false;
            return;
          }

          const card = this.querySelector(`.store-selector-item[data-handle="${event.detail.store}"]`);
          if ( card ) {
            card.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
          }
        });

        this.interactiveMap.addEventListener('ready', () => {
          const selectedStore = localStorage.getItem('selected-store');
          const focusHandle = this.pendingMapFocus || selectedStore;
          if ( focusHandle ) {
            this._focusAceMap(focusHandle, true);
            this.pendingMapFocus = null;
          }
        });
      }

      this._syncAceSelectedStore();
    }

    _setAceStatus(card) {
      const statusEl = card.querySelector('[data-status-text]');
      const closingEl = card.querySelector('.store-selector-item__closing-times');
      if ( ! statusEl || ! closingEl ) return;

      try {
        const timeZone = closingEl.dataset.timezone || 'America/New_York';
        const localTime = new Date(new Date().toLocaleString('en-US', { timeZone }));
        const today = localTime.getDay();
        const nowMin = localTime.getHours() * 60 + localTime.getMinutes();
        const closingRows = closingEl.querySelectorAll('p');
        const closingText = closingRows[today]?.textContent.trim();

        const hours = StoreSelector.STORE_HOURS[card.dataset.handle];

        // With known hours we can tell whether the store is open RIGHT NOW; the
        // closing-times block only ever gave the close time, so it read "Open until 7pm"
        // even at 9pm. When closed, surface the next opening instead.
        if ( hours ) {
          const isOpenDay = (d) => { const [o, c] = hours[d]; return !(o === 0 && c === 0); };
          const [open, close] = hours[today];

          if ( isOpenDay(today) && nowMin >= open * 60 && nowMin < close * 60 ) {
            // Open now — prefer the merchant-configured close text, fall back to the table.
            const until = (closingText && closingText.toLowerCase() !== 'closed')
              ? closingText.replace('Closing at ', 'until ')
              : `until ${StoreSelector.formatHour(close)}`;
            statusEl.innerHTML = `<span class="sl-open">Open ${until}</span>`;
            return;
          }

          // Closed now — find the next opening (later today, else the next open day).
          if ( isOpenDay(today) && nowMin < open * 60 ) {
            statusEl.innerHTML = `<span class="sl-closed">Closed &middot; Opens ${StoreSelector.formatHour(open)}</span>`;
            return;
          }
          for ( let i = 1; i <= 7; i++ ) {
            const d = (today + i) % 7;
            if ( isOpenDay(d) ) {
              const when = i === 1 ? 'tomorrow' : StoreSelector.DAY_NAMES[d];
              statusEl.innerHTML = `<span class="sl-closed">Closed &middot; Opens ${StoreSelector.formatHour(hours[d][0])} ${when}</span>`;
              return;
            }
          }
          statusEl.innerHTML = '<span class="sl-closed">Closed</span>';
          return;
        }

        // No hours table for this handle — fall back to the closing-times block only.
        if ( ! closingText ) return;
        if ( closingText.toLowerCase() === 'closed' ) {
          statusEl.innerHTML = '<span class="sl-closed">Closed today</span>';
        } else {
          statusEl.innerHTML = `<span class="sl-open">Open ${closingText.replace('Closing at ', 'until ')}</span>`;
        }
      } catch(e) {}
    }

    _toggleAceDetails(card) {
      const details = card.querySelector('[data-details-panel]');
      const button = card.querySelector('[data-toggle-details]');
      if ( ! details || ! button ) return;

      const shouldOpen = details.hasAttribute('hidden');
      details.toggleAttribute('hidden', ! shouldOpen);
      card.classList.toggle('sl-card--expanded', shouldOpen);
      button.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
    }

    _syncAceSelectedStore() {
      const selectedStore = localStorage.getItem('selected-store');
      const selectedCard = selectedStore ? this.querySelector(`.store-selector-item[data-handle="${selectedStore}"]`) : null;
      const sortedCards = this._getAceSortedCards();

      this.cards.forEach(card => {
        const isSelected = card === selectedCard;
        card.classList.toggle('sl-card--mine', isSelected);
        card.classList.toggle('store-selector-item--store--active', isSelected);
        card.querySelector('input') && (card.querySelector('input').checked = isSelected);
        card.querySelector('[data-set-store]')?.toggleAttribute('hidden', isSelected);
        card.querySelector('[data-current-store]')?.toggleAttribute('hidden', ! isSelected);
      });

      if ( selectedCard && this.myStoreContainer && this.myStoreSection ) {
        this.myStoreContainer.appendChild(selectedCard);
        this.myStoreSection.hidden = false;
      } else if ( this.myStoreSection ) {
        this.myStoreSection.hidden = true;
      }

      sortedCards.forEach(card => {
        if ( card !== selectedCard ) {
          this.nearbyContainer?.appendChild(card);
        }
      });

      this.changeSelectedStoreHandleContent(selectedCard ? selectedCard.dataset.handle : null);
    }

    _setAceSelectedStore(handle) {
      if ( ! handle || ! this.storesList[handle] ) return;

      localStorage.setItem('selected-store', handle);
      this._syncAceSelectedStore();
      this._focusAceMap(handle, true);
      this.dispatchEvent(new CustomEvent('storechanged'));
    }

    _getAceSortedCards() {
      return [...this.cards].sort((a, b) => {
        const aDistance = Number(a.dataset.distanceValue);
        const bDistance = Number(b.dataset.distanceValue);
        const aHasDistance = Number.isFinite(aDistance);
        const bHasDistance = Number.isFinite(bDistance);

        if ( aHasDistance && bHasDistance ) return aDistance - bDistance;
        if ( aHasDistance ) return -1;
        if ( bHasDistance ) return 1;
        return Number(a.dataset.order || 0) - Number(b.dataset.order || 0);
      });
    }

    _sortAceStoresFrom(point, successMessage) {
      this.cards.forEach(card => {
        const lat = parseFloat(card.dataset.lat);
        const lng = parseFloat(card.dataset.lng);
        const distanceEl = card.querySelector('[data-distance]');
        const badgeEl = card.querySelector('[data-closest-badge]');

        if ( ! Number.isFinite(lat) || ! Number.isFinite(lng) ) return;

        const distance = this._getAceDistanceMiles(point.lat, point.lng, lat, lng);
        card.dataset.distanceValue = distance.toFixed(4);
        if ( distanceEl ) {
          distanceEl.textContent = this._formatAceDistance(distance);
          distanceEl.hidden = false;
        }
        if ( badgeEl ) badgeEl.hidden = true;
      });

      const nearest = this._getAceSortedCards()[0];
      this.nearestHandle = nearest?.dataset.handle || null;

      if ( nearest ) {
        nearest.querySelector('[data-closest-badge]')?.removeAttribute('hidden');
        this._focusAceMap(nearest.dataset.handle, true);
      }

      this._syncAceSelectedStore();
      this._showAceLocationStatus(successMessage, 'success');
      this.dispatchEvent(new CustomEvent('storelocationsearched'));
    }

    _focusAceMap(handle, recenter) {
      if ( ! recenter ) return;
      if ( ! this.interactiveMap || ! this.interactiveMap.markers || ! this.interactiveMap.markers[handle] || typeof google === 'undefined' ) {
        this.pendingMapFocus = handle;
        return;
      }
      this.suppressNextMarkerScroll = true;
      google.maps.event.trigger(this.interactiveMap.markers[handle], 'click');
    }

    _geocodeAceLocation(query) {
      return this._ensureGoogleMaps().then(() => new Promise((resolve, reject) => {
        const geocoder = new google.maps.Geocoder();
        geocoder.geocode({
          address: query,
          componentRestrictions: { country: 'US' }
        }, (results, status) => {
          if ( status !== 'OK' || ! results || ! results[0] ) {
            reject(status);
            return;
          }

          const location = results[0].geometry.location;
          resolve({ lat: location.lat(), lng: location.lng() });
        });
      }));
    }

    _attachAceLocationAutocomplete() {
      if ( ! this.locationInput || this.locationInput.dataset.googlePlacesBound === 'true' ) return;
      this.locationInput.dataset.googlePlacesBound = 'true';

      this._ensureGoogleMaps()
        .then(() => {
          if ( typeof google === 'undefined' || ! google.maps?.places?.Autocomplete ) return;

          const autocomplete = new google.maps.places.Autocomplete(this.locationInput, {
            componentRestrictions: { country: 'us' },
            fields: ['address_components', 'formatted_address', 'geometry', 'place_id'],
            types: ['geocode']
          });

          autocomplete.addListener('place_changed', () => {
            const place = autocomplete.getPlace();
            const location = place?.geometry?.location;
            if ( ! location ) return;

            const address = place.formatted_address || this.locationInput.value.trim();
            this.locationInput.value = address;
            this._setAceLocationLoading(true, 'Searching stores...');
            this._sortAceStoresFrom({
              lat: location.lat(),
              lng: location.lng()
            }, `Stores closest to ${address}`);
            this._setAceLocationLoading(false);
          });
        })
        .catch(() => {});
    }

    _ensureGoogleMaps() {
      if ( typeof google !== 'undefined' && google.maps ) {
        return Promise.resolve();
      }

      if ( typeof KROWN === 'undefined' || ! KROWN.settings?.google_maps_api_key ) {
        return Promise.reject();
      }

      return new Promise((resolve, reject) => {
        const waitForMaps = setInterval(() => {
          if ( typeof google !== 'undefined' && google.maps ) {
            clearInterval(waitForMaps);
            resolve();
          }
        }, 100);

        setTimeout(() => {
          if ( typeof google === 'undefined' || ! google.maps ) {
            clearInterval(waitForMaps);
            reject();
          }
        }, 10000);

        if ( window.loadingGoogleMapsScript ) return;

        window.loadingGoogleMapsScript = true;
        window.initLocalMap = window.initLocalMap || (() => {});
        const googleScript = document.createElement('script');
        googleScript.defer = true;
        googleScript.setAttribute('loading', 'async');
        googleScript.src = `https://maps.googleapis.com/maps/api/js?v=3&key=${KROWN.settings.google_maps_api_key}&libraries=places&callback=window.initLocalMap`;
        googleScript.onerror = reject;
        document.body.appendChild(googleScript);
      });
    }

    _setAceLocationLoading(isLoading, message = '') {
      if ( this.locationButton ) this.locationButton.disabled = isLoading;
      if ( this.geoButton ) this.geoButton.disabled = isLoading;
      if ( message ) this._showAceLocationStatus(message, 'loading');
    }

    _showAceLocationStatus(message, type = 'neutral') {
      if ( ! this.locationStatus ) return;
      this.locationStatus.textContent = message;
      this.locationStatus.dataset.type = type;
      this.locationStatus.hidden = false;
    }

    _getAceDistanceMiles(lat1, lng1, lat2, lng2) {
      const earthRadius = 3958.8;
      const toRadians = value => value * Math.PI / 180;
      const dLat = toRadians(lat2 - lat1);
      const dLng = toRadians(lng2 - lng1);
      const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(toRadians(lat1)) * Math.cos(toRadians(lat2)) *
        Math.sin(dLng / 2) * Math.sin(dLng / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      return earthRadius * c;
    }

    _formatAceDistance(distance) {
      return `${distance.toFixed(distance < 10 ? 1 : 0)} mi`;
    }

    _openStoreTab(item) {
      // Panels are selected by class now — role="tabpanel" was removed along
      // with the tab pattern (see sections/stores-map.liquid).
      const open = item.classList.contains('store-selector-item--active') ? false : true;
      this.querySelectorAll('.store-selector-item--active').forEach(elm=>{
        this._slideUp(elm.querySelector('.js-tab-panel'), 200);
        elm.classList.remove('store-selector-item--active');
        this._setExpanded(elm, false);
      });
      if ( open ) {
        item.classList.add('store-selector-item--active');
        this._slideDown(item.querySelector('.js-tab-panel'), 200);
      }
      this._setExpanded(item, open);
    }

    /** Keep the disclosure button's announced state in step with the panel. */
    _setExpanded(item, expanded) {
      const toggle = item.querySelector('.js-accordion-tab-toggle');
      if ( toggle ) toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    }
    
    _clearSelectedStore(item) {
      if ( ! item.classList.contains('store-selector-item--store--active') && this.querySelector('.store-selector-item--store--active') ) {
        this.querySelector('.store-selector-item--store--active input').checked = false;
        this.querySelector('.store-selector-item--store--active').classList.remove('store-selector-item--store--active');
      }
    }

    _setSelectedStore(item, button) {
      item.classList.toggle('store-selector-item--store--active');
      if ( this.mainSelector ) {
        item.querySelector('input').checked = !item.querySelector('input').checked;
        button.setAttribute('aria-selected', button.getAttribute('aria-selected') == "true" ? "false" : "true");
        if ( this.storeSelectorButton ) {
          if ( item.classList.contains('store-selector-item--store--active') ) {
            this.storeSelectorButton.style.display = "block";
          } else {
            this.storeSelectorButton.style.display = "none";
          }
        }
      }
    }

    changeSelectedStoreHandleContent(store = null) {
      
      if ( this.mainSelector ) {

        document.querySelectorAll('[data-type="store-selector"]').forEach(storeSelectorHandle=>{

          if ( store ) {

            // get closing time

            let storeClosingHours = '';
            if ( document.querySelector('.store-selector-item--store--active .store-selector-item__closing-times') ) {
              const today = new Date().getDay();
              const closingTimes = document.querySelector('.store-selector-item--store--active .store-selector-item__closing-times').querySelectorAll('p');
              if ( closingTimes[today] ) {
                storeClosingHours = ` &nbsp;|&nbsp; ${closingTimes[today].textContent}`;
              }
            }

            storeSelectorHandle.querySelector('[data-store-title]').innerHTML = `${KROWN.settings.locales.store_selector_title_selected}${storeClosingHours}`;
            storeSelectorHandle.querySelector('[data-store-label]').textContent = this.storesList[store];

            if ( this.storeSelectorButton ) {
              this.storeSelectorButton.classList.add('show-change-label');
              this.storeSelectorButton.classList.remove('show-select-label');
            }

          } else {

            storeSelectorHandle.querySelector('[data-store-title]').textContent = KROWN.settings.locales.store_selector_title_default;
            storeSelectorHandle.querySelector('[data-store-label]').textContent = KROWN.settings.locales.store_selector_label;

          }

        })

      }

    }

		_slideUp(target, duration){
			target.style.transitionProperty = 'height, margin, padding';
			target.style.transitionDuration = duration + 'ms';
			target.style.boxSizing = 'border-box';
			target.style.height = target.offsetHeight + 'px';
			target.offsetHeight;
			target.style.overflow = 'hidden';
			target.style.height = 0;
			target.style.paddingTop = 0;
			target.style.paddingBottom = 0;
			target.style.marginTop = 0;
			target.style.marginBottom = 0;
			setTimeout(()=>{
				target.style.display = 'none';
				target.style.removeProperty('height');
				target.style.removeProperty('padding-top');
				target.style.removeProperty('padding-bottom');
				target.style.removeProperty('margin-top');
				target.style.removeProperty('margin-bottom');
				target.style.removeProperty('overflow');
				target.style.removeProperty('transition-duration');
				target.style.removeProperty('transition-property');
			}, duration);
		}

		_slideDown(target, duration) {
			target.style.removeProperty('display');
			var display = window.getComputedStyle(target).display;

			if (display === 'none')
				display = 'block';

			target.style.display = display;
			var height = target.offsetHeight;
			target.style.overflow = 'hidden';
			target.style.height = 0;
			target.style.paddingTop = 0;
			target.style.paddingBottom = 0;
			target.style.marginTop = 0;
			target.style.marginBottom = 0;
			target.offsetHeight;
			target.style.boxSizing = 'border-box';
			target.style.transitionProperty = "height, margin, padding";
			target.style.transitionDuration = duration + 'ms';
			target.style.height = height + 'px';
			target.style.removeProperty('padding-top');
			target.style.removeProperty('padding-bottom');
			target.style.removeProperty('margin-top');
			target.style.removeProperty('margin-bottom');
			setTimeout(()=>{
				target.style.removeProperty('height');
				target.style.removeProperty('overflow');
				target.style.removeProperty('transition-duration');
				target.style.removeProperty('transition-property');
			}, duration);
		}

  }

  if ( typeof customElements.get('store-selector') == 'undefined' ) {
    customElements.define('store-selector', StoreSelector);
  }

}

/* cache-bust 1777573489740 */
